import { IErrorResponse } from '@common/api.models';
import { AxiosError } from 'axios';
import { QueryKey, UseMutationResult } from '@tanstack/react-query';
import { MouseEventHandler } from 'react';
import { IProjectFileBase } from '@file/projectFile/projectFile.models';

export enum ETempWorkType {
  T2DesignBrief = 'T2 Design Brief',
  T3DesignModifications = 'T3 Design Modifications',
  T4PermitsToLoadOrRemove = 'T4 Permits to load/ remove',
  DesignerTransmittal = "Designer's Transmittal",
  SiteTransmittal = "Site's Transmittal",
  CheckerTransmittal = "Checker's Transmittal",
  CheckCertificates = 'Check Certificates',
  LambethReviewRequest = 'Lambeth Review Request',
  LambethInternalReview = 'Lambeth Independent Review',
}
export interface IDetailPageRightMenuTemporaryWorksFormsItem {
  type: ETempWorkType;
  onClickAdd?: MouseEventHandler<HTMLButtonElement>;
  onClickAddMutationFn?: UseMutationResult<any, AxiosError<IErrorResponse, any>, any, unknown>;
  onClickAddMutationParam?: { [key: string]: any };
  queryKeyToInvalidAfterSuccessAdd?: QueryKey;
  data?: IDetailPageRightMenuTemporaryWorksFormsItemData[];
  onClickData?: (data: IDetailPageRightMenuTemporaryWorksFormsItemData) => string;
  isAddEnable?: boolean;
  shouldDisableCount?: boolean;
}

export interface IDetailPageRightMenuTemporaryWorksFormsItemData {
  id: number;
  title?: string;
  status?: ETemporaryWorksFormsItemDataStatus;
  projectFile?: IProjectFileBase;
}
export enum ERightMenuItemType {
  LINK = 'LINK',
  DOWNLOAD = 'DOWNLOAD',
}
export enum ETemporaryWorksFormsItemDataStatus {
  TWC = 'TWC',
  TWD = 'TWD',
  DRAFT = 'DRAFT',
  CANCEL = 'CANCEL',
  COMPLETE = 'COMPLETE',
  ICE = 'ICE',
  SRP = 'SRP',
  COMPLETE_SRP = 'COMPLETE_SRP',
  COMPLETE_REMOVAL_REQUIRED = 'COMPLETE_REMOVAL_REQUIRED',
  COMPLETE_CHOP = 'COMPLETE_CHOP',
  CHOP = 'CHOP',
  PM = 'PM',
}
